import { render, staticRenderFns } from "./InvoicePrizeData.vue?vue&type=template&id=792e8e0a&"
import script from "./InvoicePrizeData.vue?vue&type=script&lang=js&"
export * from "./InvoicePrizeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports